var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "974.7px",
    height: "1461.9px",
    viewBox: "0 0 974.7 1461.9",
    enableBackground: "new 0 0 974.7 1461.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.711,311.974c-3.491-0.511-10.166-5.763-12.559-11.387 c-1.916-4.501-2.22-9.312-2.498-14.051c-0.448-7.651-0.272-16.216,0.239-24.364c2.448,1.461,5.81,2.522,6.723,2.193 c0.18,1.754-0.488-1.301,0.49,3.813s4.251,10.233,6.27,12.703c1.645,1.133,1.388,2.828,1.399,3.829 c0.073,6.373-0.005,12.748-0.026,19.122C436.74,306.506,436.768,310.403,436.711,311.974z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.676,175.108c0,0,1.948-1.348,2.829-1.69c1.879-0.729,2.509-2.139,2.5-4 c-0.007-1.292-0.194-3.745-0.194-3.745s4.552-2.044,6.764-2.192c5.563-0.371,11.149-0.386,16.726-0.528 c2.973-0.077,4.683,0.249,7.476,0.185s3.81,0.056,6.092,1.138s5.911,2.81,6.874,3.227s4.636,2.323,5.914,3.271 c0.585,0.69,0.813,2.685,0.563,4.521s-0.828,2.798-2.111,5.109c-1.83-0.546-7.091-2.858-9.949-4.14s-8.472-2.759-12.419-3.145 s-15.612-0.394-18.644-0.064s-8.344,1.797-8.344,1.797l-3.498,1.38L455.676,175.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.998,303.819c-1.826-6.209-3.199-15.997-3.162-17.75 s0.329-5.554,0.22-7.601c0.877-3.105,2.776-6.395,3.909-8.258c1.791,0.731,4.349,0.768,5.591,0.439 c0.219,0.95,0.192,2.489,0.099,3.113C524.148,283.764,521.948,298.732,518.998,303.819z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtLight);
export default __webpack_public_path__ + "static/media/CT_light.d6c14ac8.svg";
export { ForwardRef as ReactComponent };